

define('modules/application/dataProvider',[
  "app",

  // Libs
  "backbone"
],

function(app, Backbone) {
  var DataProvider = Backbone.Model.extend({
    defaults : {
      items : {}
    },

    initialize:function()
    {
      window.BticinoS4B.eventAggregator.bind("modelDeliver:request", this.resetItems, this);
    },

    resetItems:function()
    {
      this.set("items", []);
    },

    getArrayToFill:function(section)
    {
      //Check if exist already an array for this section
      if (this.get("items")[section])
        return this.get("items")[section];
      else
        return [];
    },

    //This method is used to add items in a particular section
    addItems:function(section, itemsToAdd)
    {
      var arrayToFill,
          dbItems = this.get("items"),
          i;

      //If all the required parameters are given to the function
      if (section && itemsToAdd)
      {
        arrayToFill = this.getArrayToFill(section);

        //If the user passed an array of itemsToAdd
        if (itemsToAdd instanceof Array)
        {
          for(i=0; i<itemsToAdd.length; i++)
          {
            if (/*!itemsToAdd.partOfKit &&*/ itemsToAdd[i].quantity>0)
              arrayToFill.push(itemsToAdd[i]);
          }
        }
        else
        {
          if (itemsToAdd.quantity>0)
            arrayToFill.push(itemsToAdd);
        }

        dbItems[section] = arrayToFill;
        this.set("items", dbItems);

        return true;
      }
      else
      {
        return false;
      }
    },

    addItemsToZone:function(zoneNumber, zoneName, itemsToAdd)
    {
      if (zoneNumber!==undefined && zoneName!==undefined && itemsToAdd!==undefined)
      {
        var dbItems             = this.get("items"),
            section             = "zonesItems",
            zonesItems          = dbItems[section] ? dbItems[section] : [],
            zonesWithThisNumber = _.filter(zonesItems, function(iterableZone){return iterableZone.number===zoneNumber;}),
            zoneToFill          = zonesWithThisNumber.length>0 ? zonesWithThisNumber[0]  : {name : zoneName, number : zoneNumber, items : []},
            i;

        //If the user passed an array of itemsToAdd
        if (itemsToAdd instanceof Array)
        {
          for(i=0; i<itemsToAdd.length; i++)
          {
            //if (!itemsToAdd[i].partOfKit && itemsToAdd[i].quantity>0)
            zoneToFill.items.push(itemsToAdd[i]);
          }
        }
        else
        {
          if (/*!itemsToAdd.partOfKit &&*/ itemsToAdd.quantity>0)
            zoneToFill.items.push(itemsToAdd);
        }

        if (zonesWithThisNumber.length===0)
          zonesItems.push(zoneToFill);

        dbItems[section]      = zonesItems;
        this.set("items", dbItems);
        //console.log(dbItems);

        return true;
      }
      else
      {
        return false;
      }
    },

    getGrandTotal:function()
    {
      var dbItems     = this.get("items"),
          grandTotal  = 0.00,
          i           = 0,
          j           = 0;

      for(var section in dbItems)
      {
        if (section!=="hasObject")
        {
          for (i = dbItems[section].length - 1; i >= 0; i--)
          {
            if (dbItems[section][i].items instanceof Array)
            {
              for(j=0; j<dbItems[section][i].items.length; j++)
              {
                if (dbItems[section][i].items[j].price && dbItems[section][i].items[j].quantity && dbItems[section][i].items[j].partOfKit!==true)
                  grandTotal += Number(dbItems[section][i].items[j].price) * Number(dbItems[section][i].items[j].quantity);
              }
            }
            else
            {
              if (dbItems[section][i].price && dbItems[section][i].quantity && dbItems[section][i].partOfKit!==true)
                grandTotal += Number(dbItems[section][i].price) * Number(dbItems[section][i].quantity);
            }
          }
        }
      }

      return grandTotal;
    },

    aggregateProducts:function(productsToAggregate)
    {
      var supportArray = [],
          sumQuantities= function(memo, iterableItem){return memo+iterableItem.quantity;};

      productsToAggregate = _.groupBy(productsToAggregate, function(iterableItem){return iterableItem.productCode;});

      for (var code in productsToAggregate)
        supportArray.push(_.extend(_.extend({}, productsToAggregate[code][0]), {quantity : _.reduce(productsToAggregate[code], sumQuantities, 0)}));

      return supportArray;
    },

    retrieveMaterialList:function()
    {
      var dbItems        = this.get("items"),
          flattenedItems = [],
          i              = 0;

      for(var section in dbItems)
      {
        if (section!=="hasObject")
        {
          for(i=0; i<dbItems[section].length; i++)
          {
            if (dbItems[section][i])
              if (dbItems[section][i].items instanceof Array)
                for(j=0; j<dbItems[section][i].items.length; j++)
                {
                  flattenedItems.push(dbItems[section][i].items[j]);
                }
              else
              {
                flattenedItems.push(dbItems[section][i]);
              }
          }
        }
      }

      var productsInPriceList     = this.aggregateProducts(_.filter(flattenedItems, function(iterableItem){return iterableItem.price && (iterableItem.price > 0);})),
          productsNotInPriceList  = this.aggregateProducts(_.filter(flattenedItems, function(iterableItem){return (!iterableItem.price || iterableItem.price === 0);}));

      return {
        productsInPriceList    : productsInPriceList,
        productsNotInPriceList : [] //productsNotInPriceList
      };
    },

    aggregateProductsBySection:function(itemsToAggregate){
      var externalItems     = itemsToAggregate.externalItems,
          zonesItems        = itemsToAggregate.zonesItems,
          automaticItems    = itemsToAggregate.automaticItems,
          configurationItems= itemsToAggregate.configurationItems,
          optionalItems     = itemsToAggregate.optionalItems,
          supportArray      = [],
          arrayToAnalize    = [],
          productType,
          i = 0, j = 0;

      var getProductCode                        = function(iterableItem){return iterableItem.productCode;},
          sumQuantities                         = function(memo, iterableItem){return memo+iterableItem.quantity;},
          filterNullProductCodeAndNullQuantity  = function(iterableItem){return !iterableItem.partOfKit && iterableItem.productCode!=="__ND__" && iterableItem.quantity>0;},
          notPartOfKit                          = function(iterableItem) {return !iterableItem.partOfKit;};

      //External items
      if (externalItems)
      {
        arrayToAnalize = _.filter(externalItems, function(item){return !item.partOfKit;});
        externalItems = _.groupBy(arrayToAnalize, getProductCode);
      }

      for(productType in externalItems)
        supportArray.push(_.extend(_.extend({}, externalItems[productType][0]), {quantity : _.reduce(externalItems[productType], sumQuantities, 0)}));

      itemsToAggregate.externalItems = _.filter(supportArray, filterNullProductCodeAndNullQuantity);
      
      //Zones items
      if (zonesItems)
      {
        for (i = zonesItems.length - 1; i >= 0; i--)
        {
          supportArray = [];

          zonesItems[i].items = _.groupBy(_.filter(zonesItems[i].items, notPartOfKit), getProductCode);

          for(productType in zonesItems[i].items)
          {
            supportArray.push(_.extend(_.extend({}, zonesItems[i].items[productType][0]), {quantity : _.reduce(zonesItems[i].items[productType], sumQuantities, 0)}));
          }

          zonesItems[i].items = _.filter(supportArray, filterNullProductCodeAndNullQuantity);
        }
        itemsToAggregate.zonesItems = zonesItems;
      }

      //Automatic items
      if (automaticItems)
      {
        for ( i = automaticItems.length - 1; i >= 0; i--) {
          if(automaticItems[i].wizardChoices && automaticItems[i].wizardChoices.length===1)
            _.extend(automaticItems[i], automaticItems[i].wizardChoices[0]);
        }
        supportArray   = [];
        automaticItems = _.groupBy(automaticItems, getProductCode);

        for(productType in automaticItems)
          supportArray.push(_.extend(_.extend({}, automaticItems[productType][0]), {quantity : _.reduce(automaticItems[productType], sumQuantities, 0)}));

        itemsToAggregate.automaticItems = _.filter(supportArray, filterNullProductCodeAndNullQuantity);
      }

      //Configuration items
      if (configurationItems)
      {
        for ( i = configurationItems.length - 1; i >= 0; i--) {
          if(configurationItems[i].wizardChoices && configurationItems[i].wizardChoices.length===1)
            _.extend(configurationItems[i], configurationItems[i].wizardChoices[0]);
        }

        supportArray       = [];
        configurationItems = _.groupBy(configurationItems, getProductCode);

        for(productType in configurationItems)
          supportArray.push(_.extend(_.extend({}, configurationItems[productType][0]), {quantity : _.reduce(configurationItems[productType], sumQuantities, 0)}));

        itemsToAggregate.configurationItems = _.filter(supportArray, filterNullProductCodeAndNullQuantity);
      }

      //Optional items
      if (optionalItems)
      {
        supportArray       = [];
        optionalItems = _.groupBy(optionalItems, getProductCode);

        for(productType in optionalItems)
          supportArray.push(_.extend(_.extend({}, optionalItems[productType][0]), {quantity : _.reduce(optionalItems[productType], sumQuantities, 0)}));

        itemsToAggregate.optionalItems = _.filter(supportArray, filterNullProductCodeAndNullQuantity);
      }

      return itemsToAggregate;
    },

    retrieveMaterialOverview:function()
    {
      return this.aggregateProductsBySection(this.get("items"));
    },

    retrieveMaterialOverviewInReportVersion:function()
    {
      var materialOverview = this.retrieveMaterialOverview(),
          toOutput         = {},
          sectionName      = "",
          globalCounter    = 0,
          supportArray,
          i = 0, j = 0;

      var toCompatibleFormat = function(item, counter) {
        return {
          progNumber        : counter,
          productCode       : (item.productCode.indexOf("__ND__")!==0) ? item.productCode : "",
          productDescription: $.i18n._((item.productLabel && item.productLabel!=="") ? item.productLabel : item.productLabel),
          quantity          : item.quantity,
          singlePrice       : (item.price ? item.price.toFixed(2)+" €" : "-"),
          amount            : item.price ? (item.quantity*item.price).toFixed(2)+" €" : "-",
          singlePriceWithoutCurrency: (item.price ? item.price.toFixed(2) : 0)
        };
      };

      toOutput.externalItems = {
        section : $.i18n._("IDS_W1_9034"),
        data    : []
      };

      //External items
      if (materialOverview.externalItems && materialOverview.externalItems.length>0)
      {
        toOutput.externalItems = {
          section : $.i18n._("IDS_W1_9034"),
          data    : [{
            section : $.i18n._("IDS_W1_9111"),
            items   : []
          }]
        };

        for (i=0; i<materialOverview.externalItems.length; i++)
        {
          toOutput.externalItems.data[0].items.push(toCompatibleFormat(materialOverview.externalItems[i], globalCounter));
          globalCounter++;
        }
      }

      toOutput.automaticItems = {
        section : $.i18n._("IDS_W1_9035"),
        data    : []
      };

      //Automatic items
      if (materialOverview.automaticItems && materialOverview.automaticItems.length>0)
      {

        supportArray = _.groupBy(materialOverview.automaticItems, function(iterableItem){return iterableItem.wizardChoiceId;});
        _.each(supportArray, function(groupOfItems){

          var toInsert = {
            section : $.i18n._(groupOfItems[0].wizardChoiceLabel),
            items   : []
          };

          for (i=0; i<groupOfItems.length; i++)
          {
            toInsert.items.push(toCompatibleFormat(groupOfItems[i], globalCounter));
            globalCounter++;
          }

          toOutput.automaticItems.data.push(toInsert);

        });
      }

      //Configuration items
      if (materialOverview.configurationItems && materialOverview.configurationItems.length>0)
      {

        supportArray = _.groupBy(materialOverview.configurationItems, function(iterableItem){return iterableItem.wizardChoiceId;});
        _.each(supportArray, function(groupOfItems){

          var toInsert = {
            section : $.i18n._(groupOfItems[0].wizardChoiceLabel),
            items   : []
          };

          for (i=0; i<groupOfItems.length; i++)
          {
            toInsert.items.push(toCompatibleFormat(groupOfItems[i], globalCounter));
            globalCounter++;
          }

          toOutput.automaticItems.data.push(toInsert);

        });
      }


      //Optional items
      toOutput.optionalItems = {
        section : $.i18n._("IDS_W1_9035"),
        data    : []
      };

      //Configuration items
      if (materialOverview.optionalItems && materialOverview.optionalItems.length>0)
      {
        supportArray = _.groupBy(materialOverview.optionalItems, function(iterableItem){return iterableItem.wizardChoiceId;});
        _.each(supportArray, function(groupOfItems){

          var toInsert = {
            section : $.i18n._(groupOfItems[0].wizardChoiceLabel),
            items   : []
          };

          for (i=0; i<materialOverview.optionalItems.length; i++)
          {
            toInsert.items.push(toCompatibleFormat(materialOverview.optionalItems[i], globalCounter));
            globalCounter++;
          }

          toOutput.optionalItems.data.push(toInsert);

        });
      }

      //Zone items
      if (materialOverview.zonesItems)
      {
        var zoneToSend;
        toOutput.zones = [];
        for (i=0; i<materialOverview.zonesItems.length; i++)
        {
          zoneToSend = {};
          zoneToSend.zoneNumber   = materialOverview.zonesItems[i].number>0 ? materialOverview.zonesItems[i].number : "";
          zoneToSend.zoneName     = $.i18n._(materialOverview.zonesItems[i].name).replace("{defaultName}", $.i18n._("IDS_WTR1001_9003"));
          zoneToSend.items        = [];

          for (j=0; j<materialOverview.zonesItems[i].items.length; j++)
          {
            if (materialOverview.zonesItems[i].items[j])
            {
              zoneToSend.items.push(toCompatibleFormat(materialOverview.zonesItems[i].items[j], globalCounter));
              globalCounter++;
            }
          }
          toOutput.zones.push(zoneToSend);
        }
      }

      return toOutput;
    },

    retrieveMaterialListInReportVersion:function()
    {
      var materialList = this.retrieveMaterialList(),
          i            = 0;

      for (i = materialList.productsInPriceList.length - 1; i >= 0; i--) {
        materialList.productsInPriceList[i] = {
          amount            : materialList.productsInPriceList[i].price ? (materialList.productsInPriceList[i].price*materialList.productsInPriceList[i].quantity).toFixed(2)+ " €" : "-",
          productCode       : materialList.productsInPriceList[i].productCode.indexOf("__ND__")===0 ? "" : materialList.productsInPriceList[i].productCode,
          productDescription: $.i18n._(materialList.productsInPriceList[i].productLabel),
          progNumber        : i,
          quantity          : materialList.productsInPriceList[i].quantity,
          singlePrice       : materialList.productsInPriceList[i].price ? (materialList.productsInPriceList[i].price).toFixed(2)+ " €" : "-",
          singlePriceWithoutCurrency: materialList.productsInPriceList[i].price ? (materialList.productsInPriceList[i].price).toFixed(2) : 0
        };
      }

      for (i = materialList.productsNotInPriceList.length - 1; i >= 0; i--) {
        materialList.productsNotInPriceList[i] = {
          amount            : materialList.productsNotInPriceList[i].price ? (materialList.productsNotInPriceList[i].price*materialList.productsNotInPriceList[i].quantity).toFixed(2)+ " €" : "-",
          productCode       : materialList.productsNotInPriceList[i].productCode.indexOf("__ND__")===0 ? "" : materialList.productsNotInPriceList[i].productCode,
          productDescription: $.i18n._(materialList.productsNotInPriceList[i].productLabel),
          progNumber        : i,
          quantity          : materialList.productsNotInPriceList[i].quantity,
          singlePrice       : materialList.productsNotInPriceList[i].price ? (materialList.productsNotInPriceList[i].price).toFixed(2)+ " €" : "-",
          singlePriceWithoutCurrency: materialList.productsNotInPriceList[i].price ? (materialList.productsNotInPriceList[i].price).toFixed(2) : 0
        };
      }

      return materialList;
    }

  });

  //Return class due to AMD compliance
  return DataProvider;

});